/**
 * TEMPORARY: Region-specific details for Lunar New Year site takeover only.
 * Used because LAB cannot currently set content per region.
 * Remove when LAB supports region-based messaging or after lunar-new-year campaign ends.
 *
 * Theme id must be exactly "lunar-new-year" (from siteTakeoverTheme.id).
 */

import { formatCurrency } from 'lib/format/formatCurrencyIntl'

export const LUNAR_NEW_YEAR_THEME_ID = 'lunar-new-year'

interface LunarNewYearRegionAmounts {
  silverAmount: string
  goldAmount: string
}

const LUNAR_NEW_YEAR_AMOUNTS_BY_REGION: Readonly<Record<string, LunarNewYearRegionAmounts>> = {
  SG: {
    silverAmount: formatCurrency(1000, 'SGD', 'SG', { format: 'roundedDollar' }),
    goldAmount: formatCurrency(3000, 'SGD', 'SG', { format: 'roundedDollar' }),
  },
  MY: {
    silverAmount: formatCurrency(3200, 'MYR', 'MY', { format: 'roundedDollar' }),
    goldAmount: formatCurrency(9500, 'MYR', 'MY', { format: 'roundedDollar' }),
  },
  HK: {
    silverAmount: formatCurrency(6000, 'HKD', 'HK', { format: 'roundedDollar' }),
    goldAmount: formatCurrency(18200, 'HKD', 'HK', { format: 'roundedDollar' }),
  },
  ZA: {
    silverAmount: formatCurrency(13000, 'ZAR', 'ZA', { format: 'roundedDollar' }),
    goldAmount: formatCurrency(38000, 'ZAR', 'ZA', { format: 'roundedDollar' }),
  },
}

/**
 * Returns region-specific loyalty spend amounts for the Lunar New Year campaign, or undefined if none for this region.
 * @param regionCode - current region code (e.g. from GeoContext), case-insensitive for lookup
 */
export function getLunarNewYearRegionAmounts(
  regionCode: string | undefined,
): LunarNewYearRegionAmounts | undefined {
  if (!regionCode) {
    return undefined
  }
  const key = regionCode.toUpperCase()
  return LUNAR_NEW_YEAR_AMOUNTS_BY_REGION[key]
}
